export default "__VITE_ASSET__DyxU5bed__"